import {
    LAYER_MAPMARKER_PRIMARY_COLOUR,
    PLANNING_SERVICES_EMAIL, PLANNING_SERVICES_PHONE,
    PLANNING_SERVICES_PHONE_INTERNATIONAL,
    STORM_SURGE, RIVERINE, STORM_1000, STORM_100,
    FLOOD_SUB_PATH, FLOOD_IMPACT_MAP_CLICK_ENABLED,
} from "../../environment";
import {
    lotBoundaryWmsSource
} from "../map/map.constants";
import MapMarkers, {MapMarker} from "../map/MapMarkers";
import React, {useEffect, useState} from "react";
import {MapConfigComponentProps} from "../map/MapComponent";
import {useFloodData} from "./util";
import VctFooter from "../vct-footer/VctFooter";
import {FloodInformationData, getSelectedFloodLayer, getSelectedTab, switchFloodLayer, switchFloodTab} from "./slice";
import {useAppDispatch, useAppSelector} from "../../common/store";
import {selectParcel} from "../../common/slice";
import {replaceSpaceWithX, useQuery} from "../../common/util";
import {Accordion, Segment, Form, Checkbox} from "semantic-ui-react";
import Toggle from "./Toggle";
import {MapBrowserEvent} from "ol";
import {useHistory} from "react-router-dom";
import {StyledLayerType} from "../flood-components/slice";
import {useFloodMapData} from "./floodMapData.hook";

const FloodMapConfig = ({map, zoomTo, setReturnLocation, onSingleClick}: MapConfigComponentProps) => {
    const primaryMarker = useFloodData()
    const activeTab = useAppSelector(getSelectedTab)
    const activeFloodLayer = useAppSelector(getSelectedFloodLayer)
    const dispatch = useAppDispatch()
    const query = useQuery()
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeRadio, setActiveRadio] = useState<string | number | undefined | null>(activeTab)
    const history = useHistory()
    const {layers} = useFloodMapData()

    if (map) {
        map.setLayers(layers)
    }

    useEffect(
        () => {
            if (primaryMarker) {
                if (query.get('zoomto') !== 'false') zoomTo(primaryMarker)
                setReturnLocation(primaryMarker)
                dispatch(selectParcel(replaceSpaceWithX(primaryMarker.laisKey)))
            }
        },
        [primaryMarker],
    )

    useEffect(() => {
        if (activeRadio === STORM_SURGE) {
            dispatch(switchFloodTab(STORM_SURGE))
        } else {
            dispatch(switchFloodTab(RIVERINE))
        }
    }, [activeRadio])

    useEffect(() => {
        if (map) {
            if (activeTab === STORM_SURGE) {
                setActiveRadio(STORM_SURGE);
            } else {
                setActiveRadio(RIVERINE);
            }

            map.on('singleclick', handleSingleClick)
            return () => {
                map.un('singleclick', handleSingleClick)
            }
        }
    }, [map, activeFloodLayer, activeTab])

    const renderStormSwitch = () => {
        return (
            <div>
                <div style={{display: 'flex'}}>
                    <Toggle label={'100y'} isToggleOn={!(activeFloodLayer === STORM_100)} onClick={(value) => {
                        if (value) {
                            dispatch(switchFloodLayer(STORM_1000))
                        } else {
                            dispatch(switchFloodLayer(STORM_100))
                        }
                    }}/>
                    1000y
                </div>
            </div>
        )
    }

    function floodOverlayRadioGroup() {
        return (
            <Form>
                <Form.Field>
                    <Checkbox
                        radio
                        label={RIVERINE}
                        name="checkboxRadioGroup"
                        value={RIVERINE}
                        checked={activeTab === RIVERINE}
                        onClick={(e, props) => dispatch(switchFloodTab(RIVERINE))}
                        onChange={(e, data) => setActiveRadio(data.value)}
                    />
                </Form.Field>
                <Form.Field>
                    <div>
                        <Checkbox
                            radio
                            label={STORM_SURGE}
                            name="checkboxRadioGroup"
                            value={STORM_SURGE}
                            checked={activeTab === STORM_SURGE}
                            onClick={(e, props) => dispatch(switchFloodTab(STORM_SURGE))}
                            onChange={(e, props) => setActiveRadio(props.value)}
                        />
                    </div>
                    {activeTab === STORM_SURGE && renderStormSwitch()}
                </Form.Field>
            </Form>
        )
    }

    function renderFloodLayerToggle() {
        return (
            <div className={'mapLayerDetails'}>
                <Accordion>
                    <Segment compact>
                        <Accordion.Title
                            active={activeIndex === 0}
                            content={'Flood Overlay'}
                            index={0}
                            onClick={(e, titleProps) => {
                                const index = titleProps.index as number
                                setActiveIndex(activeIndex === index ? -1 : index)
                            }}
                        />
                        <Accordion.Content active={activeIndex === 0} content={floodOverlayRadioGroup()}/>
                    </Segment>
                </Accordion>
            </div>
        )
    }

    const handleSingleClick = async (evt: MapBrowserEvent<UIEvent>) => {
        if (FLOOD_IMPACT_MAP_CLICK_ENABLED) {
            const placeObj: any = await onSingleClick(evt, lotBoundaryWmsSource);
            if (placeObj) {
                let laiskey: string = replaceSpaceWithX(placeObj.properties.LAISKEY)
                let path = `${FLOOD_SUB_PATH}/${laiskey}`
                history.push(path)
            }
        }
    }

    return (
        <React.Fragment>
            {primaryMarker &&
                <MapMarkers map={map}>
                    <MapMarker<FloodInformationData>
                        latitude={primaryMarker.latitude}
                        longitude={primaryMarker.longitude}
                        data={primaryMarker}
                        iconColor={LAYER_MAPMARKER_PRIMARY_COLOUR}
                        iconSize={'big'}/>
                </MapMarkers>
            }
            <VctFooter contactEmail={PLANNING_SERVICES_EMAIL} contactPhone={PLANNING_SERVICES_PHONE}
                       contactPhoneInternational={PLANNING_SERVICES_PHONE_INTERNATIONAL}/>
            {map && renderFloodLayerToggle()}
        </React.Fragment>
    )
}

export default FloodMapConfig